import Rest from '../Rest';

export default class UserService extends Rest {

        static resource = '/users';

        async create(data) {
    
            return await this.post(`/`, data)                    
               
        }

        async update(data) {   
            
            return await this.put('/', data);
    
        }

        async updatePassword(data) {

            return await this.patch('/recoverPass/' + data.token, { password: data.password });
    
        }
            
        async recoverEmail(email, locale) {
    
            try {
    
                return await this.post(`/recoverEmail/?locale=${locale}`, { email });
    
            } catch (error) {
    
                throw new Error(error)
            }
        }

        async login(email, password) {

                try {
                        return await this.post('/login', {
                                email,
                                password,
                        });
                } catch {
                        return null;
                }
        }

        async logout() {
                try {
                        return await this.post('/logout', {});
                } catch {
                        return null;
                }
        }
}